import { observer } from 'mobx-react';
import React, { Component } from 'react';
import classNames from 'classnames';
import Label from './Label';
import Model from '../model/ShopKeeper.model';

interface IProps {
  model: Model;
  onPPCValidated: Function;
  resetPPC: Function;
  skipPPC: Function;
}

@observer
class PPCAuthenticator extends Component<IProps, {}> {
  model: Model;

  ppcInput: HTMLInputElement;
  ppcPasswordInput: HTMLInputElement;

  constructor(props: IProps) {
    super(props);
    this.model = props.model;
  }

  clear() {
    this.ppcInput.value = '';
  }

  focus() {
    if (this.model.ppcPasswordNeeded) {
      this.ppcPasswordInput.focus();
    } else {
      this.ppcInput.focus();
    }
  }

  render() {
    return (
      <div className="sk-ppc">
        <div>
          <Label>PPC</Label>
          {this.model.ppcValidated ? (
            <div
              className={classNames({
                'sk-ppcAttributionOverride': this.model.ppcAttributionReplayActive,
                'sk-ppcValidated': true,
              })}
              onDoubleClick={() => {
                if (!this.model.ppcAttributionReplayActive) {
                  setTimeout(this.props.resetPPC, 0);
                }
              }}
            >
              {this.model.ppcAttributionReplayActive ? this.model.ppcAttribution : this.model.ppcParams.ppc}
            </div>
          ) : (
            <input
              onBlur={async (evt: any) => {
                if (evt.target.value === '') {
                  return;
                }

                const seedRun = this.model.isInitialSeedRun; // important to cache pre-loadPPC

                // Was this an authentic PPC?  If not, try again.
                // If so, the PPC may need to be validated with a password.
                if (!(await this.model.loadPPC(evt.target.value))) {
                  this.ppcInput.value = '';
                  this.ppcInput.focus();
                }
                // Did this PPC already validate? (no PW required - so model sets validated in one shot)
                if (this.model.ppcValidated) {
                  this.props.onPPCValidated(seedRun);
                }
              }}
              onKeyPress={(evt: any) => {
                if (evt.key === 'Enter') {
                  if (evt.target.value === '') {
                    this.props.skipPPC();
                    return;
                  } else {
                    this.ppcInput.blur();
                  }
                }
              }}
              ref={(ref: HTMLInputElement) => {
                this.ppcInput = ref;
              }}
              style={{ width: '6em' }}
              type="text"
            />
          )}
        </div>
        {!this.model.ppcValidated && this.model.ppcPasswordNeeded && (
          <div className="sk-ppcPassword">
            <Label>PPC Password</Label>
            <input
              autoFocus={true}
              onBlur={(evt: any) => {
                if (evt.target.value === '') {
                  return;
                }

                const seedRun = this.model.isInitialSeedRun; // important to cache pre-validatePPCPassword

                if (!this.model.validatePPCPassword(evt.target.value)) {
                  this.ppcPasswordInput.value = '';
                  setTimeout(() => this.ppcPasswordInput.focus(), 100);
                } else {
                  // PPC is validated
                  setTimeout(() => this.props.onPPCValidated(seedRun), 100);
                }
              }}
              onKeyPress={(evt: any) => {
                if (evt.key === 'Enter' && evt.target.value !== '') {
                  this.ppcPasswordInput.blur();
                }
              }}
              ref={(ref: HTMLInputElement) => (this.ppcPasswordInput = ref)}
              style={{ width: '6em' }}
              type="password"
            />
          </div>
        )}
      </div>
    );
  }
}

export default PPCAuthenticator;
